import './QualitativeSamplesManagement.css';

import React, { useState } from 'react';
import { getAreaDisabledDataRanges } from '../../components/helper';
import { CommonInfo } from '../quant/QuantitativeObjectiveManagement';
import QualitativeSamplesTable from './QualitativeSamplesTable';
import QualitativeSampleEditForm from '../../components/samples/QualitativeSampleEditForm';

const QualitativeSamplesManagement = ({ areaIndicator, onRefresh = null }) => {
    const [showSampleEditForm, setShowSampleEditForm] = useState(false);
    const [sampleSelected, setSampleSelected] = useState(null);

    const disabledDateRanges = getAreaDisabledDataRanges(areaIndicator.area);

    const handleSampleClick = (sample) => {
        setSampleSelected(sample);
        setShowSampleEditForm(true);
    };

    const handleSavedQualitativeSample = (sample) => {
        setShowSampleEditForm(false);
        onRefresh && onRefresh();
    };

    const handleDeletedQualitativeSample = (sample) => {
        setShowSampleEditForm(false);
        onRefresh && onRefresh();
    };

    return (
        <>
            <CommonInfo areaIndicator={areaIndicator} />
            <QualitativeSamplesTable
                areaIndicator={areaIndicator}
                onSampleClick={handleSampleClick}
                onNewSample={() => {
                    setSampleSelected(null);
                    setShowSampleEditForm(true);
                }}
            />
            {
                showSampleEditForm &&
                <QualitativeSampleEditForm
                    sample={sampleSelected}
                    planUUID={areaIndicator.area.plan.planUUID}
                    areaId={areaIndicator.area.areaId}
                    areaIndicatorId={areaIndicator.areaIndicatorId}
                    indicator={areaIndicator.indicatorDTO}
                    disabledDateRanges={disabledDateRanges}
                    onCancel={() => setShowSampleEditForm(false)}
                    onSave={handleSavedQualitativeSample}
                    onDelete={handleDeletedQualitativeSample}
                />
            }
        </>
    );
};

export default QualitativeSamplesManagement;